export const refreshVariableSteps = (configs, steps) => Object
  .keys(configs)
  .reduce((carry, key) => {
    /* eslint-disable eqeqeq */
    const { options: selectedOptions = [] } = carry.find(({ code }) => code == key) || {};
    const { variants: selectedVariants = [] } = selectedOptions
      .find(({ id }) => id == configs[key]) || {};
    /* eslint-enable eqeqeq */

    return !selectedVariants.length
      ? carry
      : carry.map(({ code, options = [], ...step }) => ({
        ...step,
        code,
        options: code == key // eslint-disable-line eqeqeq
          ? options
          : options.map(({
            id,
            isActive = true,
            hasVariants = false,
            variants = [],
            ...option
          }) => ({
            ...option,
            id,
            isActive: id == configs[key] // eslint-disable-line eqeqeq
              ? isActive
              : selectedVariants.filter(variant => !hasVariants
              || variants.includes(variant)).length > 0,
            hasVariants,
            variants,
          })),
      }));
  }, steps);

export const getSelectedSku = (configs, steps) => new Promise(async (resolve, reject) => {
  const skus = await Object
    .keys(configs)
    .filter(key => !!configs[key])
    .reduce((carry, key) => {
      /* eslint-disable eqeqeq */
      const { options = [] } = steps.find(({ code }) => code == key) || {};

      if (!options.length) {
        return carry;
      }

      const { variants = [] } = options.find(({ id }) => id == configs[key]) || {};
      /* eslint-enable eqeqeq */

      if (!variants.length) {
        return carry;
      }

      if (!carry.length) {
        return variants.map(variant => variant);
      }

      return carry.filter(item => variants.includes(item));
    }, []);

  if (!skus.length) {
    reject(new Error('SKU cannot be determined from selections.'));
  }

  resolve(skus.pop());
});

export const getSkuUnitPrice = (selectedSku, variants) => new Promise((resolve, reject) => {
    /* eslint-disable eqeqeq */
    const selectedVariant = variants.find(variant => variant.sku == selectedSku);
    /* eslint-enable eqeqeq */

    if (selectedVariant === undefined) {
        reject(new Error('SKU unit price cannot be determined.'));
    }

    resolve(selectedVariant.unitPrice);
});



// WEBPACK FOOTER //
// ./src/ConfigurableProduct/ConfigurableProductFormHelper.js